import { useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useObservableFactory } from 'botparade';
import { fetchShare } from '../../api';
export function useModel() {
    var slug = useParams().slug;
    var _a = useState(slug || ''), slugText = _a[0], setSlugText = _a[1];
    var share = useObservableFactory(function () { return fetchShare(slug); }, [slug]);
    var history = useHistory();
    var load = function () {
        history.replace("/" + slugText.toUpperCase());
    };
    return {
        slug: slugText,
        setSlug: function (text) { setSlugText(text.toUpperCase()); },
        share: share,
        load: load,
    };
}
